import script from "./select.vue?vue&type=script&lang=ts&setup=true"
export * from "./select.vue?vue&type=script&lang=ts&setup=true"

import "./select.vue?vue&type=style&index=0&id=40bc09a8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bc09a8"]])

export default __exports__